/* Bunpharma Theme — Interaktionen (Mobile Navigation, Cookie-Hinweis) */
(function () {
  'use strict';

  /* ---------- Mobile Navigation ---------- */
  var nav = document.querySelector('[data-mobile-nav]');
  var openBtn = document.querySelector('[data-nav-open]');
  var closeBtn = document.querySelector('[data-nav-close]');

  function openNav() {
    if (!nav) return;
    nav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    var firstLink = nav.querySelector('.mobile-nav__close');
    if (firstLink) firstLink.focus();
  }

  function closeNav() {
    if (!nav) return;
    nav.classList.remove('is-open');
    document.body.style.overflow = '';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    if (openBtn) openBtn.focus();
  }

  if (openBtn) openBtn.addEventListener('click', openNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  if (nav) {
    nav.querySelector('.mobile-nav__backdrop').addEventListener('click', closeNav);
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeNav);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  /* ---------- Obfuskierte E-Mail-Adressen ---------- */
  document.querySelectorAll('[data-email-user]').forEach(function (el) {
    el.addEventListener('click', function () {
      var addr = el.getAttribute('data-email-user') + '@' +
        el.getAttribute('data-email-domain') + '.' +
        el.getAttribute('data-email-tld');
      var label = el.querySelector('[data-email-label]');
      if (label) label.textContent = addr;
      window.location.href = 'mailto:' + addr;
    });
  });

  /* ---------- Produktdetail: Galerie & Zoom ---------- */
  var mediaFrame = document.querySelector('[data-product-media]');
  var mainImage = document.querySelector('[data-product-main-image]');
  var thumbs = document.querySelectorAll('[data-product-thumb]');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImage) return;
      mainImage.src = thumb.getAttribute('data-full');
      mainImage.setAttribute('data-zoom-src', thumb.getAttribute('data-zoom'));
      var alt = thumb.getAttribute('data-alt');
      if (alt) mainImage.alt = alt;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mediaFrame) {
        mediaFrame.classList.remove('is-zoomed');
        mainImage.style.transformOrigin = '';
      }
    });
  });

  if (mediaFrame && mainImage) {
    mediaFrame.addEventListener('click', function () {
      mediaFrame.classList.toggle('is-zoomed');
    });
    mediaFrame.addEventListener('mousemove', function (e) {
      if (!mediaFrame.classList.contains('is-zoomed')) return;
      var rect = mediaFrame.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      mainImage.style.transformOrigin = x + '% ' + y + '%';
    });
  }

  /* ---------- Cookie-/Consent-Hinweis (§ 165 TKG) ---------- */
  var KEY = 'bunpharma-consent-v1';
  var banner = document.querySelector('[data-cookie-banner]');

  function consentGiven() {
    try { return localStorage.getItem(KEY) !== null; } catch (e) { return true; }
  }

  if (banner && !consentGiven()) {
    setTimeout(function () { banner.classList.add('is-visible'); }, 600);
    banner.querySelectorAll('[data-consent]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        try {
          localStorage.setItem(KEY, JSON.stringify({
            choice: btn.getAttribute('data-consent'),
            at: new Date().toISOString()
          }));
        } catch (e) { /* Speicher nicht verfügbar */ }
        banner.classList.remove('is-visible');
      });
    });
  }
})();
